import { render } from "./categorySelect.vue?vue&type=template&id=07c0f1ce"
import script from "./categorySelect.vue?vue&type=script&lang=js"
export * from "./categorySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__